<template>
  <v-container>
    <router-view></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'product',
  data() {
    return {}
  },
  created() {
  },
}
</script>
